import { APP_DISPLAY_NAME, DEFAULT_THEME_APP_EMBED_HANDLE } from "./appBranding";

const trimTrailingSlashes = (url) =>
  typeof url === "string" ? url.replace(/\/+$/, "") : "";

export const NODE_API_URL =
  trimTrailingSlashes(process.env.REACT_APP_API_URL) || "http://localhost:7000";
/** API routes (session auth) live under /api — install stays on NODE root */
export const NODE_API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || "/api";

/**
 * Theme app embed block handle = Liquid filename without .liquid (e.g. calendar.liquid → calendar).
 * Deep link: appEmbed={SHOPIFY_API_KEY}%2F{handle}
 */
export const THEME_APP_EMBED_HANDLE = (
  process.env.REACT_APP_THEME_APP_EMBED_HANDLE ||
  process.env.REACT_APP_THEME_BLOCK_HANDLE ||
  DEFAULT_THEME_APP_EMBED_HANDLE
).trim();

/** @deprecated use THEME_APP_EMBED_HANDLE */
export const THEME_BLOCK_HANDLE = THEME_APP_EMBED_HANDLE;
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN || "http://localhost:3000";
export const REACT_APP_BASE_PATH = process.env.REACT_APP_BASE_PATH || "";

export const SHOPIFY_API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY || "";

/** Theme editor deep link: "activate" = context=apps + activateAppId (needs deployed extension). "embeds_only" = App embeds panel only (no error if embed missing). */
export const THEME_EDITOR_LINK_MODE =
  (process.env.REACT_APP_THEME_EDITOR_LINK_MODE || "activate").trim() || "activate";

if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  const k = process.env.REACT_APP_SHOPIFY_API_KEY || "";
  if (k.startsWith("shpss_")) {
    console.warn(
      `[${APP_DISPLAY_NAME}] REACT_APP_SHOPIFY_API_KEY looks like an API secret (shpss_). Use the public Client ID from Partners — not the secret — or theme links show “app does not exist”.`,
    );
  }
}

/**
 * React Router basename when Partner App URL includes a path segment (e.g. /orbits-events-calendar-widget).
 * Leave REACT_APP_SHOPIFY_APP_HANDLE empty when the embedded app is served at `/` only.
 */
export const SHOPIFY_APP_HANDLE = (process.env.REACT_APP_SHOPIFY_APP_HANDLE || "").trim();

/** Admin apps URL slug — for docs/messages; see DEFAULT_SHOPIFY_APP_HANDLE in appBranding.js */
export { DEFAULT_SHOPIFY_APP_HANDLE, APP_DISPLAY_NAME, APP_SHORT_NAME } from "./appBranding";

function detectRouterBasename() {
  if (SHOPIFY_APP_HANDLE) return `/${SHOPIFY_APP_HANDLE}`;
  if (typeof window !== "undefined") {
    const path = window.location.pathname || "";
    const match = path.match(/^\/([^/]+)\/(widgets|registrations|settings|events)(\/|$)/);
    if (match && match[1]) return `/${match[1]}`;
  }
  return "";
}

export const ROUTER_BASENAME = detectRouterBasename();

export const IS_PRODUCTION = process.env.NODE_ENV === "production";
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";

export const API_BASE_URL = `${NODE_API_URL}${NODE_API_BASE_PATH}`;

export const buildNodeApiEntryUrl = (shop, host = null) => {
  if (!shop) return `${NODE_API_URL}/`;
  return host
    ? `${NODE_API_URL}/?shop=${encodeURIComponent(shop)}&host=${encodeURIComponent(host)}`
    : `${NODE_API_URL}/?shop=${encodeURIComponent(shop)}`;
};

export const APP_BASE_URL = `${REACT_APP_DOMAIN}${REACT_APP_BASE_PATH}`;

const config = {
  nodeApi: {
    url: NODE_API_URL,
    basePath: NODE_API_BASE_PATH,
    fullUrl: API_BASE_URL,
  },
  reactApp: {
    domain: REACT_APP_DOMAIN,
    basePath: REACT_APP_BASE_PATH,
    fullUrl: APP_BASE_URL,
  },
  shopify: {
    apiKey: SHOPIFY_API_KEY,
  },
  env: {
    isProduction: IS_PRODUCTION,
    isDevelopment: IS_DEVELOPMENT,
    nodeEnv: process.env.NODE_ENV,
  },
};

export default config;
